import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Form } from '@ant-design/compatible';
import * as userActions from '../../core/user/userActions';
import DOM from './loginForm';
import { notification } from 'antd';

const { REGEX_VALID_EMAIL } = require('../../core/constants').default;

class UserLoginForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isVisiblePasswordResetModal: false,
            passwordResetEmail: '',
        };
        this.view = DOM;
    }

    submitting = false;

    componentDidMount() {
        document.querySelector("body").addEventListener("keyup", this.handleInput);
    }

    componentDidUpdate(prevProps) {
        const { loginError } = this.props;

        if (loginError && prevProps.loginError !== loginError) {
            this.submitting = false;
        }
    }

    componentWillUnmount() {
        document.querySelector("body").removeEventListener('keyup', this.handleInput);
    }

    clickSubmitBtn = (e) => {
        if (e?.key !== "Enter") {
            return;
        }
        e?.preventDefault();
        handleSubmit();
    }

    setIsVisiblePasswordResetModal(isVisiblePasswordResetModal) {
        this.setState({ isVisiblePasswordResetModal });
    }

    setPasswordResetEmail = (e) => {
        this.setState({ passwordResetEmail: e.target.value });
    }

    handleSubmit = (e = null) => {
        const { actions } = this.props;
        if (this.submitting) {
            return;
        }
        this.submitting = true;
        e?.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                actions.loginRequest({
                    username: values.email,
                    password: values.password,
                });
            }
        });
    }

    sendPasswordResetEmail = () => {
        const { actions } = this.props;
        const { passwordResetEmail } = this.state;

        if (passwordResetEmail?.length && passwordResetEmail.match(REGEX_VALID_EMAIL)) {
            actions.resetPasswordRequest({ email: passwordResetEmail });
            this.setState({ 
                isVisiblePasswordResetModal: false,
                passwordResetEmail: '',
            });
        } else {
            notification.error({
                message: 'Error',
                description: 'Please enter a valid email address',
            });
        }
    }

    render() {
        return this.view();
    }
}

UserLoginForm.propTypes = {
    form: PropTypes.object.isRequired,
};

const LoginForm = Form.create()(UserLoginForm);

function mapStateToProps(state, ownProps) {
    return {
        ...ownProps,
        isLoggingIn: state.user.isLoggingIn,
        loginError: state.user.error,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({
            ...userActions,
        }, dispatch),
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(LoginForm);
